import { BuildingTypes, IUpdateOrderDeliveryDTO, OrdersDeliveryType } from '@/models/orders.model';

class UpdateDeliveryDTO implements IUpdateOrderDeliveryDTO {
  order_id: string;
  region_id: string;
  delivery_type: OrdersDeliveryType;
  settlement_id: string;
  address?: string;
  building_type?: BuildingTypes;
  floor?: number;
  flat_number?: string;
  freight_elevator?: '1' | '0';
  delivery_department?: string;
  delivery_warehouse_id?: string;
  comment?: string;

  constructor({
    order_id,
    region_id,
    delivery_type,
    settlement_id,
    address,
    building_type,
    floor,
    flat_number,
    freight_elevator,
    delivery_department,
    delivery_warehouse_id,
    comment,
  }: IUpdateOrderDeliveryDTO) {
    this.order_id = order_id;
    this.region_id = region_id;
    this.delivery_type = delivery_type;
    this.settlement_id = settlement_id;
    this.address = address;
    this.building_type = building_type;
    this.floor = floor;
    this.flat_number = flat_number;
    this.freight_elevator = freight_elevator;
    this.delivery_department = delivery_department;
    this.delivery_warehouse_id = delivery_warehouse_id;
    this.comment = comment;
  }
}

export default UpdateDeliveryDTO;
